// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__6MXI4","loader--svg":"Loader_loader--svg__49Uem"};